import Config from '@config';
import { initializeGasConsumingEquipmentApi } from '@gasbi/shared/common/features/gasConsumingEquipment';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  gasConsumingEquipmentApi,
  useGetGasConsumingEquipmentsQuery,
  useGetGasConsumingEquipmentByIdQuery,
  useCreateGasConsumingEquipmentsMutation,
  useUpdateGasConsumingEquipmentsMutation,
  useGetGasConsumingEquipmentsInfiniteQuery,
  getCachedEquipmentByIdSelector,
  useGetCachedEquipmentByIdSelector,
} = initializeGasConsumingEquipmentApi(Config.VITE_API_URL, axiosBaseQuery);
